import { render } from "./Altro.vue?vue&type=template&id=9e91ebaa"
import script from "./Altro.vue?vue&type=script&lang=js"
export * from "./Altro.vue?vue&type=script&lang=js"

import "./Altro.vue?vue&type=style&index=0&id=9e91ebaa&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__